import React from "react";
import { Table, Tooltip } from "antd";
import editIcon from "../../../../Assets/svg/table-action-edit.svg";
import deleteIcon from "../../../../Assets/svg/table-action-delete.svg";
import previewIcon from "../../../../Assets/svg/table-action-preview.svg";

const FacilitiesTable = ({
  data,
  loading,
  pagination,
  onPageChange,
  onEdit,
  onDelete,
  onPreview,
}) => {
  const columns = [
    {
      title: "Additonal Tools",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "space-around" }}>

          <Tooltip title="Edit">
            <img
              src={editIcon}
              style={{ cursor: "pointer" }}
              alt="editicon"
              onClick={() => onEdit(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <img
              src={deleteIcon}
              style={{ cursor: "pointer" }}
              alt="deleteicon"
              onClick={() => onDelete(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={pagination}
      onChange={onPageChange}
      rowKey="id"
      className="mt-5"
    />
  );
};

export default FacilitiesTable;
